import { useTranslation } from "react-i18next";
import { FormAutocomplete, RowInfo } from "../common";
import { BonusPointsModal } from "./modals";

const PointsSection = ({ useQuery }) => {
  const { t } = useTranslation();

  return (
    <>
      <RowInfo help={<BonusPointsModal />}>
        <FormAutocomplete 
            label={t("Bonus Points")} 
            name="points" 
            useQuery={useQuery}
            options={[
                { id: 0, name: '0' },
                { id: 1, name: '1' },
                { id: 2, name: '2' },
                { id: 3, name: '3' },
                { id: 4, name: '4' },
                { id: 5, name: '5' },
                { id: 6, name: '6' },
                { id: 7, name: '7' },
                { id: 8, name: '8' },
                { id: 9, name: '9' },
                { id: 10, name: '10' },
                { id: 20, name: '20' },
                { id: 30, name: '30' },
                { id: 40, name: '40' },
                { id: 50, name: '50' },
                { id: 60, name: '60' },
                { id: 70, name: '70' },
                { id: 80, name: '80' },
                { id: 90, name: '90' },
                { id: 99, name: '99' },
            ]}
            size="small"
            creatable
        />
      </RowInfo>
    </>
  );
};

export default PointsSection;
